import { genLandingPage, genLandingPageGSSP } from '@/pages/landing-page';

export default genLandingPage();
export const getServerSideProps = genLandingPageGSSP('/press');
